<div class="container border rounded pt-4 pb-2">
	<div class="row text-center mb-4">
		<span class="theme-main-color fw-bold fs-4">
			Distance parcourue par employé
		</span>
	</div>
	<div class="row my-2">
		<div echarts [options]="travelDistance"></div>
	</div>
</div>
